/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * List all Fund Families
 */
export const fundFamilyListQueryParams = zod.object({
  "commitment_id": zod.string().optional(),"investor_entity_id": zod.string().optional(),"investor_id": zod.string().optional()
})

/**
 * Create a new Fund Family
 */
export const fundFamilyCreateQueryParams = zod.object({
  "investor_class_name": zod.string().optional(),"skip_create_defaults": zod.boolean().optional()
})

export const fundFamilyCreateBodyAnnotationsSetMin = 2;
export const fundFamilyCreateBodyAnnotationsSetMax = 2;

export const fundFamilyCreateBody = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(fundFamilyCreateBodyAnnotationsSetMin).max(fundFamilyCreateBodyAnnotationsSetMax)).optional(),"name": zod.string().min(1),"target_first_close": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).min(1),"target_raise": zod.string().min(1),"notes": zod.string().optional(),"state": zod.enum(['draft', 'fundraising', 'active', 'dissolved', 'deleted', ""]).optional(),"formation_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Lists fund family events for a fund family
 */
export const fundFamilyEventListParams = zod.object({
  "fundFamilyId": zod.string()
})

/**
 * Creates a new fund family event
 */
export const fundFamilyEventCreateParams = zod.object({
  "fundFamilyId": zod.string()
})

export const fundFamilyEventCreateBodyAnnotationsSetMin = 2;
export const fundFamilyEventCreateBodyAnnotationsSetMax = 2;

export const fundFamilyEventCreateBody = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(fundFamilyEventCreateBodyAnnotationsSetMin).max(fundFamilyEventCreateBodyAnnotationsSetMax)).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fund_family_id": zod.string().min(1),"type": zod.enum(['allocation_rule_change', 'configuration', 'adjustment', 'cancel_correct', 'capital_activity', 'charge_fee', 'create_fee_offsettable_expense', 'closing', 'credit_facility', 'end_of_period_report', 'investor_transfer', 'capital_call_reallocation', 'portfolio_transaction_posting']),"sub_type": zod.enum(['fund_family_config', 'fund_family_dates', 'fund_family_entity', 'fund_family_entity_with_allocation_setup', 'fund_family_investment', 'credit_facility_version', 'credit_facility_loan_version', 'borrowing_base_group_version', 'security_ownership_version', 'allocation_rule', 'allocation_rule_lookup', 'allocation_rule_graph_version', 'allocation_rule_graph_use_version', 'fee', 'fee_basis', 'fee_basis_category', 'fee_calculations', 'investor_class', 'notice', 'notice_document_template', 'security_ownership', 'transaction_calculation', 'transaction_code_config', 'waterfall', 'waterfall_config', 'waterfall_tier_mapping', 'fund_family_event_event_adjustment', 'commitment_adjustment', 'late_apply_fee_offset_adjustment', 'adjustment_event', 'drawdown', 'paydown', 'reallocation', 'post_interest', 'merge_tranches', ""]).optional(),"effective_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).min(1),"posted_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).min(1),"capital_call_effective_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"capital_call_posted_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"notes": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"celery_workflow_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"credit_facility_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"customer_event_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"distribution_withholding_upload_document_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"notice_generation_celery_workflow_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"state": zod.enum(['draft', 'in_progress', 'completed', 'cancelled', 'out_of_date']).or(zod.union([zod.null(), zod.literal("")])).optional(),"action_type": zod.enum(['create', 'edit', ""]).optional(),"original_fund_family_event_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"custom_notice_text": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"dataclass_name": zod.any().optional()
})

/**
 * Get a specific Fund Family
 */
export const fundFamilyRetrieveParams = zod.object({
  "fundFamilyId": zod.string()
})

export const fundFamilyRetrieveResponseAnnotationsSetMin = 2;
export const fundFamilyRetrieveResponseAnnotationsSetMax = 2;

export const fundFamilyRetrieveResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(fundFamilyRetrieveResponseAnnotationsSetMin).max(fundFamilyRetrieveResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"target_first_close": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).min(1),"target_raise": zod.string().min(1),"notes": zod.string().optional(),"state": zod.enum(['draft', 'fundraising', 'active', 'dissolved', 'deleted', ""]).optional(),"formation_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Update a specific Fund Family
 */
export const fundFamilyUpdateParams = zod.object({
  "fundFamilyId": zod.string()
})

export const fundFamilyUpdateBodyAnnotationsSetMin = 2;
export const fundFamilyUpdateBodyAnnotationsSetMax = 2;

export const fundFamilyUpdateBody = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(fundFamilyUpdateBodyAnnotationsSetMin).max(fundFamilyUpdateBodyAnnotationsSetMax)).optional(),"name": zod.string().min(1),"target_first_close": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).min(1),"target_raise": zod.string().min(1),"notes": zod.string().optional(),"state": zod.enum(['draft', 'fundraising', 'active', 'dissolved', 'deleted', ""]).optional(),"formation_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

export const fundFamilyUpdateResponseAnnotationsSetMin = 2;
export const fundFamilyUpdateResponseAnnotationsSetMax = 2;

export const fundFamilyUpdateResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(fundFamilyUpdateResponseAnnotationsSetMin).max(fundFamilyUpdateResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"target_first_close": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).min(1),"target_raise": zod.string().min(1),"notes": zod.string().optional(),"state": zod.enum(['draft', 'fundraising', 'active', 'dissolved', 'deleted', ""]).optional(),"formation_date": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Delete a Fund Family
 */
export const fundFamilyDestroyParams = zod.object({
  "fundFamilyId": zod.string()
})

export const fundFamilyDestroyQueryParams = zod.object({
  "customer_id": zod.string().optional()
})

